(() => {
'use strict';
    function initStaffPushSlider() {

    const numberOfSlides = document.querySelectorAll(`.staff-push-slider .splide__slide`).length;

    const splide = new Splide(`.staff-push-slider__splide`, {
      type: 'slide',
      rewind: true,
      autoplay: false,
      snap: false,
      focus: 0,
      perPage: 1,
      autoWidth: true,
      pagination: false,
      arrows: false,
      gap: '40px',
      trimSpace: true,
      drag: numberOfSlides < 2 ? false : true,
      breakpoints: {
        767: {
          flickPower: 100,
          gap: '24px',
        },
      },
    });

    const progressBar = splide.root.querySelector('.product-slider__progress-bar');

    // Updates the bar width whenever the carousel moves:
    splide.on('mounted move', function () {
      const end = splide.Components.Controller.getEnd() + 1;
      const rate = Math.min((splide.index + 1) / end, 1);
      progressBar.style.width = String(100 * rate) + '%';
    });

    splide.mount();


    }

    initStaffPushSlider();

    })();
